import styled from 'styled-components';
import { cssWhiteSection } from 'components/base/common-styles';
import { SIZES } from 'common/constants/sizes';
import { StyledMonteCarloSimulation } from './MonteCarloSimulation/MonteCarloSimulation.style';

export const StyledForecast = styled.div`
  ${cssWhiteSection};
  min-height: 50rem;
  display: flex;
  flex-direction: column;
  font-size: ${SIZES.medium};

  & ${StyledMonteCarloSimulation} {
    min-height: 40rem;
  }
`;
